import React from 'react'
import CheckboxInput from '../inputs/CheckboxInput'

export default function PaymentMethod({children, value, label, description, icon = null}) {
    return (
        <div className={'payment-method'}>
            <CheckboxInput
                label={label}
                value={value}
                name={'method'} subobj={'payment'}
            />
            {description && (<div className={'payment-method__description'} dangerouslySetInnerHTML={{ __html: description }} />)}

            {children}

            {icon && (
                <img className="payment-icon" src={icon.url ?? null} alt={icon.alt ?? null} />
            )}
        </div>
    )
}